var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm1.315-16.662A1.32 1.32 0 0011.977 6a1.32 1.32 0 00-1.338 1.338 1.32 1.32 0 001.338 1.339 1.32 1.32 0 001.338-1.339zM9.5 9.308h3.815v5.307c0 .431.108.662.554.662h.631v1.23H9.546v-1.23h.662c.446 0 .553-.23.553-.662V11.2c0-.43-.107-.661-.553-.661H9.5V9.308z",
    fill: "#222"
  })));
}
export default SvgInfoToast;